export default "__VITE_ASSET__68c66cea__"